<template>
  <div :class="['o-feed-section-content', $store.getters.getIsClientData === false
      ? 'o-feed-section-content-upgrade' : '']">
    <!--<MoleculeFeedSectionContentInfo/>-->
    <div class="o-feed-section-content-cards">
      <MoleculeFeedSectionContentCard
        :is="moleculeCardDesign2"
        v-for="element in elements"
        :key="element.id"
        :element="element"
        :element-categorias="elementCategorias"
      />
      <MoleculeFeedSectionLoading v-show="showAddingState"/>
    </div>
    <MoleculeFeedSectionContentFooter/>
  </div>
</template>

<script>
export default {
  name: 'OrganismFeedSectionContent',

  props: {
    elements: Array,
    elementCategorias: Array,
    showAddingState: Boolean
  },

  data () {
    return {
      moleculeCardDesign2: () => import('@/components/molecules/MoleculeFeedSectionContentCardDesign2')
    }
  },

  components: {
    // MoleculeFeedSectionContentInfo: () => import('@/components/molecules/MoleculeFeedSectionContentInfo'),
    MoleculeFeedSectionContentFooter: () => import('@/components/molecules/MoleculeFeedSectionContentFooter'),
    MoleculeFeedSectionLoading: () => import('@/components/molecules/MoleculeFeedSectionLoading')
  }
}
</script>
